import React, { Component } from "react";
import { withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch" 
import {getMessagemErro} from "../../utils/erro";
import api from "../../services/api";
import { isIP } from 'is-ip';
import './SolicitacaoCadastroArquivosGrandesVolumes.css';
import { FEDERAL, ESTADUAL, MUNICIPAL } from "../../providers/constEsferasAdministrativas";
import { SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory } from "./AttachmentsAndHistory";
import { Tooltip } from "../UI/Tooltip/Tooltip";
import { ConfirmationModal } from "../UI/ConfirmationModal/ConfirmationModal";
import { SecureDirectoryClientInformation } from "../SecureDirectory/SecureDirectoryClientInformation";
import { validaCamposNumericos } from "../../utils/formValidationUtil";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const ArquivoGrandesVolumesEdit =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(
	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				grandeVolume: {
                    id: undefined,
					numero: '',
					nomeSituacao: '',
					cedenteDosDados: this.props.user.nomeOrgao,
					esferasAdministrativas: [],
					cpfDirigenteTi: '',
					cpfResponsavelTecnico: '',
					titulo: "",
					descricao: "",
					arquivos: [],
					justificativa: '',
					alteracaoPermitida: true,
					ativo: true,
					orgaoPossuiPastaSeguraConfigurada: false,
					so: '',
					ipsInternet: '',
				},
                arquivo: {
                    isEdit: false,
					index: null,
                    nome: "",
                    extensaoArquivo: "",
					tamanho: "",
                    periodicidade: "",
                    descricao: "",
					ativo: true,
                },
				extensoes: [],
				esferasAdministrativasDisponiveis: [ESTADUAL, FEDERAL, MUNICIPAL],
                dirigentesTi: [],
                responsaveisTecnicos: [],
				carregandoSolicitacaoGrandeVolume: true,
                carregandoDirigentesTi: false,
				carregandoExtensoes: false,
				carregandoResponsaveisTecnicos: false,
				periodicidades: [],
				botoesHabilitados : true,
				exibeModalLiberaracaoAnalise : false,
				dataHoraCarregamentoPagina: new Date(),
			};
			this.handleInputChange = this.handleInputChange.bind(this);
            this.handleArquivoInputChange = this.handleArquivoInputChange.bind(this);
			this.handleArquivoAtivoChange = this.handleArquivoAtivoChange.bind(this);
			this.salvar = this.salvar.bind(this);
			this.novo = this.novo.bind(this);		
            this.carregarDirigentesTi = this.carregarDirigentesTi.bind(this);
			this.carregarResponsaveisTecnicos = this.carregarResponsaveisTecnicos.bind(this);
            this.addArquivo = this.addArquivo.bind(this);
            this.editarArquivo = this.editarArquivo.bind(this);
            this.updateArquivo = this.updateArquivo.bind(this);
            this.deleteArquivo = this.deleteArquivo.bind(this);
            this.arquivosRef = React.createRef();
            this.fechaModal = this.fechaModal.bind(this);
			this.onChangePropertiesSecureDirectoryClientInformation = this.onChangePropertiesSecureDirectoryClientInformation.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
						<Message />
						<Loading />
						
						<div  style={{margin: "10px"}}>
							<h1>Solicitação de Cadastro de Arquivos de Grandes Volumes</h1>
						</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			const isEditSolicitacao = !this.props.location.pathname.includes('edit-conjunto-gv');

			if(id){
				this.setState({
				carregandoGrandeVolume: true,
			})
				const apiRequest = isEditSolicitacao ? `/api/solicitacao-cadastro-arquivo-gv/` : `/api/solicitacao-cadastro-arquivo-gv/alteracao-conjunto_arquivos-gv/`
				api.get(`${apiRequest}${id}`)
					.then(response => { 
						this.setState({ grandeVolume: {
							...response.data,
							cedenteDosDados: response.data.nomeOrgao || this.props.user.nomeOrgao,
						} }); 
						this.carregarDirigentesTi();
						this.carregarExtensoes();
						this.carregarResponsaveisTecnicos();
						this.carregarPeriodicidades();
					})
					.catch(erro => {
						const msg = getMessagemErro("Não foi possível recuperar os dados da solicitação de grande volume.", erro);
						console.log(JSON.stringify(msg));
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					}).finally(() => {
						this.setState({ carregandoGrandeVolume: false });
						this.props.escondeAguardando();
					});
			} else {
				this.carregarDirigentesTi();
				this.carregarExtensoes();
				this.carregarResponsaveisTecnicos();
				this.carregarPeriodicidades();
			}
		}

		renderForm() {

			return(
				<div className="container-fluid">
					<ConfirmationModal
						isOpen={this.state.exibeModalExcluirArquivo}
						onClose={() => this.fechaModal()}
						onConfirm={() => this.deleteArquivo()}
						message="Deseja realmente remover o arquivo?"
					/>

					<ConfirmationModal
						isOpen={this.state.exibeModalLiberaracaoAnalise}
						onClose={() => this.setState({exibeModalLiberaracaoAnalise: false})}
						onConfirm={(e) => this.salvar(e, true)}
						onCancel={() => this.setState({exibeModalLiberaracaoAnalise: false})}
						message={
							<>
								Deseja realmente liberar a solicitação para a análise?
							</>
						}></ConfirmationModal>

					{ !this.state.carregandoGrandeVolume &&

					<div className="br-form">
						<div className="row">
							{ this.state.grandeVolume.id &&
								<div className="col-6">
									<div className="field">
										<div className="input">
											<label htmlFor="numero">Número:</label>
											<input type="text" name="numero"
												value={this.state.grandeVolume.numero}  
												disabled
												/>
										</div>
									</div>
								</div>
							}
						{ this.state.grandeVolume.id &&
                            <div className="col-6">
									<div className="field">
										<div className="input">
											<label htmlFor="nomeSituacao">Situação:</label>
											<input type="text" name="nomeSituacao"
												value={this.state.grandeVolume.nomeSituacao}  
												disabled
												/>
										</div>
									</div>
								</div>
						}
                        </div>
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="cedenteDosDados">Cedente dos Dados:</label>
										<input type="text" name="cedenteDosDados" maxLength="14"
											value={this.state.grandeVolume.cedenteDosDados}  
											disabled
											/>
									</div>
								</div>
							</div>
                            <div className="col-md">
                                <div className="field">
									<div className="input">
										<label htmlFor="esferasAdministrativas">Disponível para órgãos das esferas administrativas:</label>						
									</div>
									<div>
										<SelectSearch
											id="esferasAdministrativasDisponiveis"
											name="esferasAdministrativasDisponiveis"
											isMulti={true}
											maxMultiSelectValues={3}
											options={this.state.esferasAdministrativasDisponiveis.map(esfera => ({ codigo: esfera.codigo, nome: esfera.nome }))}
											onChange={values => this.handleMultiSelectChange(values)}
											value={this.state.grandeVolume.esferasAdministrativas}
											placeholder="Nenhuma esfera administrativa selecionada"
											noOptionsMessage="Nenhuma esfera administrativa encontrada"
											optionName="nome"
											optionValue="codigo"
											disabled={!this.state.grandeVolume.alteracaoPermitida}
										/>
									</div>
								</div>
                            </div>
                        </div>
                        <div className="row">	
                            <div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label>Dirigente de TI:</label>
                                        { this.state.dirigentesTi.length > 0 && 
                                            <SelectSearch
                                                id="cpfDirigenteTi"
                                                name="cpfDirigenteTi"
                                                options={this.state.dirigentesTi.map(dirigenteTi => ({ value: dirigenteTi.cpf, label: `${dirigenteTi.cpf} - ${dirigenteTi.nome}` }))}
                                                onChange={this.handleInputChange}
                                                value={this.state.grandeVolume.cpfDirigenteTi}
                                                disabled={!this.state.grandeVolume.alteracaoPermitida}
                                            />
                                        }
                                        {this.state.carregandoDirigentesTi === true && 
                                            <button className="br-button is-secondary is-circle is-loading" type="button"/>
                                        }
                                        {this.state.carregandoDirigentesTi === false && this.state.dirigentesTi.length === 0 && "Não há dirigentes de TI cadastrados no órgão."}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md">
                                <div className="field">
                                    <div className="input">
                                        <label>Responsável Técnico:</label>
                                        { this.state.responsaveisTecnicos.length > 0 && 
                                            <SelectSearch
                                                id="cpfResponsavelTecnico"
                                                name="cpfResponsavelTecnico"
                                                options={this.state.responsaveisTecnicos.map(responsavelTecnico => ({ value: responsavelTecnico.cpf, label: `${responsavelTecnico.cpf} - ${responsavelTecnico.nome}` }))}
                                                onChange={this.handleInputChange}
                                                value={this.state.grandeVolume.cpfResponsavelTecnico}
                                                disabled={!this.state.grandeVolume.alteracaoPermitida}
                                            />
                                        }
                                        {this.state.carregandoResponsaveisTecnicos === true && 
                                            <button className="br-button is-secondary is-circle is-loading" type="button"/>
                                        }
                                        {this.state.carregandoResponsaveisTecnicos === false && this.state.responsaveisTecnicos.length === 0 && "Não há responsáveis técnicos cadastrados no órgão."}
                                    </div>
                                </div>
                            </div>
						</div>
                        <div className="row">
							<div className="col-6">
								<div className="field">
									<div className="input">
										<div className="d-flex">
											<label htmlFor="titulo">Título do conjunto de arquivo:&nbsp;</label>
											<Tooltip 
												content={
													<>
														<span>Um resumo do que está disponibilizando.</span>
														<span>Ex: Disponibilizar dados de políticas públicas do DF no período de 2000 a 2025</span>
													</>
												}
											/>
										</div>
										<input type="text" name="titulo" maxLength="100"
											value={this.state.grandeVolume.titulo}  
											onChange={this.handleInputChange}
											disabled={!this.state.grandeVolume.alteracaoPermitida}
										/>
									</div>
								</div>
							</div>
							{ this.state.grandeVolume.conjuntoArquivo &&
							<div className="col-6">
								<div className="field">
									<div className="input">
										<label>Ativo:</label>
										{ this.state.responsaveisTecnicos.length > 0 && 
											<SelectSearch
												id="ativo"
												name="ativo"
												options={[{value: true, label: 'Ativo'}, {value: false, label: 'Inativo'}]}
												onChange={this.handleInputChange}
												value={this.state.grandeVolume.ativo}
												disabled={!this.state.grandeVolume.alteracaoPermitida}
											/>
										}
									</div>
								</div>
							</div>
							}
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="field">
                                    <div className="input">
										<div className="d-flex">
											<label htmlFor="descricao">Descrição do conjunto de arquivo:&nbsp;</label>
											<Tooltip 
												content="Ex: Esses dados referem-se as políticas públicas executadas no período de 2000 a 2025 na região do DF"
											/>
										</div>
                                        <textarea name="descricao" maxLength="500" rows="4"
                                            value={this.state.grandeVolume.descricao}  
                                            onChange={this.handleInputChange}
                                            disabled={!this.state.grandeVolume.alteracaoPermitida}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4 mb-4">
                            <h2 ref={this.arquivosRef}>Arquivos</h2>
                        </div>
                        <div className="row">
                           <div className="col">
								<div className="field">
									<div className="input">
										<div className="d-flex">
										<label htmlFor="nomeArdddq">Nome:&nbsp;</label>
											<Tooltip 
												content={
													<>
														<span>Nome do arquivo (Ex: BasedeConsultadePoliticasPublicas).</span>
														<span>O nome do arquivo deve conter apenas letras e números.</span>
														<span>Sugere-se que o nome do arquivo reflita sua função negocial</span>
														<span>&nbsp;</span>
														<span>Os arquivos a serem transferidos para os órgãos consumidores devem ser disponibilizados na pasta <strong>Outbox da Pasta Segura</strong>.</span>
														<span>O nome do arquivo deve ser conforme o cadastro aprovado, podendo ser acrescentado algum sufixo para permitir diferenciar e transferir vários arquivos.</span>
														<span>Manter sempre o nome principal  e acrescentar o caracter underline (“_”) mais o sufixo desejado, preferencialmente uma data.</span>
														<span>&nbsp;</span>
														<span>Exemplos:</span>
														<span>&emsp;Nome do arquivo no cadastro : <strong>DadosCenso</strong></span>
														<span>&emsp;Extensão : <strong>zip</strong></span>
														<span>&nbsp;</span>
														<span>Possíveis nomes do arquivo a ser disponibilizado na pasta <strong>Outbox</strong> para transferência: 	</span>
														<span>&emsp;<strong>DadosCenso.zip</strong></span>
														<span>&emsp;<strong>DadosCenso_2025.zip</strong></span>
														<span>&emsp;<strong>DadosCenso_2024.zip</strong></span>
														<span>&emsp;<strong>DadosCenso_20240101.zip</strong></span>
														<span>&nbsp;</span>
														<span>O arquivo só será transferido para as pastas <strong>Inbox</strong>  dos órgãos consumidores caso o nome satisfaça a regra acima.</span>
													</>
												}
											/>
										</div>
										<input type="text" name="nome"
											value={this.state.arquivo.nome}  
											onChange={this.handleArquivoInputChange}
											disabled={!this.state.grandeVolume.alteracaoPermitida}
											/>
									</div>
								</div>
							</div>
                        </div>
                        <div className="row">
                            <div className="col">
								<div className="field">
									<div className="input">
										<label htmlFor="extensaoArquivo">Extensão:</label>
										<SelectSearch
                                            id="extensaoArquivo"
                                            name="extensaoArquivo"
                                            options={this.state.extensoes.map(extensao => ({ value: extensao.id, label: extensao.nome }))}
                                            onChange={this.handleArquivoInputChange}
                                            value={this.state.arquivo.extensaoArquivo}
                                            disabled={!this.state.grandeVolume.alteracaoPermitida}
                                        />
									</div>
								</div>
							</div>
							<div className="col">
								<div className="field">
									<div className="input">
										<label htmlFor="tamanho">Tamanho em MB (Megabytes):</label>
										<input type="number" name="tamanho" min="1"
											value={this.state.arquivo.tamanho}  
											onChange={this.handleArquivoInputChange}
											disabled={!this.state.grandeVolume.alteracaoPermitida}
											/>
									</div>
								</div>
							</div>
                            <div className="col">
								<div className="field">
									<div className="input">
										<label htmlFor="periodicidade">Periodicidade:</label>
										<SelectSearch
                                            id="periodicidade"
                                            name="periodicidade"
                                            options={this.state.periodicidades.map(periodicidade => ({ value: periodicidade.codigo, label: periodicidade.nome }))}
                                            onChange={this.handleArquivoInputChange}
                                            value={this.state.arquivo.periodicidade}
                                            disabled={!this.state.grandeVolume.alteracaoPermitida}
                                        />
									</div>
								</div>
							</div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="field">
                                        <div className="input">
											<div className="d-flex">
												<label htmlFor="descricao">Descrição:&nbsp;</label>
												<Tooltip 
													content={
														<>
															<span>Detalhar o máximo possível o conjunto de dados para facilitar o entendimento.</span>
															<span>Informe os metadados: descrição das colunas e campos</span>
															<span>Caso seja uma parte, informe o padrão de particionamento: Por exemplo: reflete o período de 2000 a 2005. Outro arquivo: reflete o período de 2006 a 2010...</span>
															<span>Ou reflete código de 1 a 100.</span>
														</>
													}
												/>
											</div>
                                            <textarea name="descricao" maxLength="500" rows="4"
                                                value={this.state.arquivo.descricao}  
                                                onChange={this.handleArquivoInputChange}
                                                disabled={!this.state.grandeVolume.alteracaoPermitida}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="actions-button mt-4">
                                <div className="actions justify-content-start">
                                    <button type="button" className="button is-secondary" onClick={this.addArquivo} disabled={!this.state.botoesHabilitados || !this.state.grandeVolume.alteracaoPermitida}>
										{this.state.arquivo.isEdit ? 'Alterar' : 'Incluir'}
									</button>
                                </div>
                            </div>
                            <fieldset className="mb-4">
							    {(this.state.grandeVolume.arquivos && this.state.grandeVolume.arquivos.length > 0) &&	
								<div className="br-table">						
									<div className="table">
										<table>		
											<thead>
												<tr>
													<th scope="col">Nome</th>
                                                    <th scope="col">Descrição</th>
													<th scope="col">Extensão</th>
													<th scope="col">Tamanho em MB (Megabytes)</th>
                                                    <th scope="col">Periodicidade</th>
													<th className="text-center" scope="col" style={{width: "5%"}}>Ativo</th>
													<th className="text-center" scope="col" style={{width: "5%"}}>Ações</th>
												</tr>
											</thead>
											<tbody>
												{ this.state.grandeVolume.arquivos.map((arq, index) =>
														<tr key={index} >
															
															<td>{arq.nome}</td>
                                                            <td>{arq.descricao}</td>
                                                            <td>{this.state.extensoes.find(ext => ext.id === arq.extensaoArquivo)?.nome}</td>
															 <td>{arq.tamanho}</td>
                                                            <td>{this.state.periodicidades.find(per => per.codigo === arq.periodicidade)?.nome}</td>
															<td className="text-center">
																<div className="actions">
																	<input 
																		type="checkbox" 
																		checked={arq.ativo !== false}
																		onChange={(e) => this.handleArquivoAtivoChange(index, e.target.checked)}
																		disabled={!arq.arquivo || !this.state.grandeVolume.alteracaoPermitida}
																	/>
																</div>
															</td>
															<td className="text-center">
																{ !arq.arquivo &&
																<div className="actions">
																	
																	<button type="button" onClick={() => this.handleDeleteArquivo(arq)} disabled={this.state.botoesHabilitados === false || !this.state.grandeVolume.alteracaoPermitida} title="Excluir arquivo">
																		<span className="sr-only">Excluir</span>
																		<i className="fas fa-trash"></i>
																	</button>

																	<button type="button" onClick={() => this.editarArquivo(arq, index)} disabled={this.state.botoesHabilitados === false || !this.state.grandeVolume.alteracaoPermitida} title="Alterar arquivo">
																		<span className="sr-only">Editar</span>
																		<i className="fas fa-edit"></i>
																	</button>
																</div>
																}
															</td>
														</tr>
													)}
											</tbody>
										</table>
									</div>
								</div>
							}
							{(!this.state.grandeVolume.arquivos || this.state.grandeVolume.arquivos.length === 0) &&
								<div>
									Nenhum arquivo cadastrado para a solicitação de grandes volumes.
								</div>
							}
						</fieldset>

						<SecureDirectoryClientInformation solicitacao={this.state.grandeVolume} onChangeProperties={this.onChangePropertiesSecureDirectoryClientInformation} readOnly={!this.state.grandeVolume.alteracaoPermitida} />
	
						{this.state.grandeVolume.id &&
							<SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory solicitacao={this.state.grandeVolume} habilitaEdicaoAnexo={true} keyHistory={this.state.dataHoraCarregamentoPagina}/>
						}

						{!this.state.grandeVolume.id && 
							<div className="row">
								<div className="col-md">
									<span style={{color: '#C9302C'}}>
									* Os documentos ficarão disponíveis para download e upload após a inclusão da solicitação. 
									</span>
								</div>
							</div> 
						}

						{/* button actions */}
						<div className="actions-button mt-4">
							<div className="actions justify-content-start">
								{this.state.grandeVolume.alteracaoPermitida && 
									<button type="button" className="button is-primary" onClick={this.salvar} disabled={!this.state.botoesHabilitados}>{this.state.grandeVolume.id ? 'Alterar' : 'Incluir'}</button>
								}
								
								{this.state.grandeVolume.liberacaoAnalisePermitida &&
									<button type="button" className="button is-secondary" onClick={() => this.setState({exibeModalLiberaracaoAnalise: true})} disabled={!this.state.botoesHabilitados}>Liberar para Análise</button>
								}

								{this.state.grandeVolume.assinaturaPermitida && 
									<Link to={`/arquivo-grandes-volumes/sign/${this.state.grandeVolume.id}`}>
										<button type="button" className="button is-secondary botaoNovo" onClick={this.assinar} disabled={!this.state.botoesHabilitados}>Assinar</button>
										</Link>
								}	

								{this.state.grandeVolume.id && 
									<button type="button" className="button is-secondary botaoNovo" onClick={this.novo} disabled={!this.state.botoesHabilitados}>Nova Solicitação</button>
								}
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

					</div>
				}
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const grandeVolume = this.state.grandeVolume;
			grandeVolume[nome] = valor;
			this.setState({ grandeVolume });
		}

        handleArquivoInputChange(evento){
            const target = evento.target;
            const nome = target.name;
            const valor = target.type === 'checkbox' ? target.checked : target.value;

            const arquivo = this.state.arquivo;
            arquivo[nome] = valor;
            this.setState({ arquivo });
        }

		handleArquivoAtivoChange(index, ativo){
			this.setState(prevState => ({
				grandeVolume: {
					...prevState.grandeVolume,
					arquivos: prevState.grandeVolume.arquivos.map((arq, idx) =>
						idx === index ? {...arq, ativo} : arq
					),
				}
			}));
		}

		handleMultiSelectChange(values){
			const esferasSelecionadas = values.target.value;
			const grandeVolume = this.state.grandeVolume;
			grandeVolume.esferasAdministrativas = esferasSelecionadas;
			this.setState(
				{ 
					grandeVolume,
				});
		}

        addArquivo(e){
            const novoArquivo = this.state.arquivo;

			try{
				this.validaArquivo();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			if (novoArquivo.isEdit) {
				const index = novoArquivo.index;
				this.updateArquivo(novoArquivo, index);
				return;
			}

			novoArquivo.auxId = Date.now();

            this.setState(prevState => ({
				grandeVolume: {
					...prevState.grandeVolume,
					arquivos: [...prevState.grandeVolume.arquivos, novoArquivo],
				},
                arquivo: {
                    nome: "",
                    extensaoArquivo: "",
					tamanho: "",
                    periodicidade: "",
                    descricao: "",
					ativo: true,
                }
            }));
        }

        editarArquivo(arquivo, index){
            this.props.limpaMensagem();
            this.setState({arquivo: {...arquivo, isEdit: true, index}});
            this.scrollParaArquivo();
        }

        updateArquivo(arquivoParaAtualizar, index){
			this.setState(prevState => ({
				grandeVolume: {
					...prevState.grandeVolume,
					arquivos: prevState.grandeVolume.arquivos.map((arq, idx) =>
						idx === index ? arquivoParaAtualizar : arq
					),
				},
				arquivo: {
					nome: "",
					extensaoArquivo: "",
					tamanho: "",
					periodicidade: "",
					descricao: "",
					ativo: true,
				}
			}));
        }

		onChangePropertiesSecureDirectoryClientInformation(nome, valor){
			const grandeVolume = this.state.grandeVolume;
			grandeVolume[nome] = valor;
			this.setState({ grandeVolume });
		}

        fechaModal () {
			this.setState(
				{
					exibeModalExcluirArquivo: false,
				}
			);
		}

        handleDeleteArquivo(arq) {
			this.setState(
				{
					exibeModalExcluirArquivo: true,
					arquivoAlvo: arq,
				}
			);
		}

        deleteArquivo(){
            const {arquivoAlvo} = this.state;

			if (arquivoAlvo.id) {
				this.setState(prevState => (
					{
						grandeVolume: {
							...prevState.grandeVolume,
							arquivos: prevState.grandeVolume.arquivos.filter(arquivo => (arquivo.id !== arquivoAlvo.id))
						}
					}
				));
			} else {
				this.setState(prevState => ({
						grandeVolume: {
							...prevState.grandeVolume,
							arquivos: prevState.grandeVolume.arquivos.filter(arquivo => arquivo.auxId !== arquivoAlvo.auxId)
						}
				}));
			}

            this.fechaModal();
        }

		novo(e){
			const rotaParaNovo = "/arquivo-grandes-volumes/new";
			if (rotaParaNovo === this.props.location.pathname) {
				this.props.history.push("/");
				this.props.history.goBack();
			} else {
				this.props.history.push(rotaParaNovo);
			}
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}

		salvar(e, liberarParaAnalise){
			this.props.limpaMensagem();
			this.setState({exibeModalLiberaracaoAnalise : false});

			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const { grandeVolume } = this.state;

			const method = grandeVolume.id ? 'put' : 'post';
			let url = '/api/solicitacao-cadastro-arquivo-gv';
			if(grandeVolume.id){
				url = url + '/' + grandeVolume.id;
			}

			grandeVolume.liberarParaAnalise = liberarParaAnalise;

			const options = {
				method,
				url,
				data: grandeVolume
			}

			this.props.mostraAguardando();
			this.setState({botoesHabilitados : false});
			api(options)
				.then(response => {
					let operacao = 'incluída';
					if(this.state.grandeVolume.id) {
						if(liberarParaAnalise) {
							operacao = 'liberada para análise';
						} else {
							operacao = 'alterada';
						}
					}
					const mensagem = `Solicitação de cadastro de arquivo de grandes volumes ${operacao} com sucesso!`;
					const grandeVolume = {
						...response.data,
						cedenteDosDados: response.data.nomeOrgao,
					}

					this.setState({
						grandeVolume,
						dataHoraCarregamentoPagina: new Date(),
					});
					this.props.exibeMensagemSucesso(mensagem);
				})
				.catch(erro => {
					const mensagemInicial = `Não foi possível ${this.state.grandeVolume.id ? 'alterar' : 'incluir'} a solicitação de cadastro de arquivo.`;
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);

				})
				.then (() =>{
					this.props.escondeAguardando();
					this.setState({botoesHabilitados:true});
				});   
		}

		validaFormulario(){
			let mensagens = [];
			const {cedenteDosDados, titulo, esferasAdministrativas, descricao, cpfDirigenteTi, cpfResponsavelTecnico, orgaoPossuiPastaSeguraConfigurada, ipsInternet, so } = this.state.grandeVolume;

			if(!cedenteDosDados || cedenteDosDados.trim().length === 0 ){
				mensagens.push({mensagem: "Cedente dos Dados é obrigatório."})
			}

			if(!esferasAdministrativas || esferasAdministrativas.length === 0){
			 	mensagens.push({mensagem: "Esfera Administrativa é obrigatória."})
			}

			if(!cpfDirigenteTi || cpfDirigenteTi.trim().length === 0 ){
			 	mensagens.push({mensagem: "CPF do Dirigente de TI é obrigatório."})
			}

			if(!cpfResponsavelTecnico || cpfResponsavelTecnico.trim().length === 0 ){
			 	mensagens.push({mensagem: "CPF do Responsável Técnico é obrigatório."})
			}

			if(!titulo || titulo.trim().length === 0 ){
			 	mensagens.push({mensagem: "Título é obrigatório."})
			}

			if(!descricao || descricao.trim().length === 0 ){
				mensagens.push({mensagem: "Descrição é obrigatória."})
			}

			if(this.state.grandeVolume.arquivos.length === 0){
				mensagens.push({mensagem: "A Solicitação deve ter pelo menos um arquivo."})
			}

			if(!orgaoPossuiPastaSeguraConfigurada){
				if(!so || so.trim().length === 0 ){
					mensagens.push({mensagem: "Sistema Operacional da pasta segura é obrigatório."})
				}

				if(!ipsInternet || ipsInternet.length === 0 ){
					mensagens.push({mensagem: "IP's de Internet é obrigatório."})
				} else {
					const ips = ipsInternet.split(',').map(ip => ip.trim());
					const ipsInvalidos = ips.filter(ip => !isIP(ip));
					if(ipsInvalidos.length > 0){
						mensagens.push({mensagem: `Os seguintes IP's de Internet são inválidos: ${ipsInvalidos.join(', ')}.`})
					}
				}
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
			 	throw new Error("Formulário não preenchido corretamente.");
			}
		}

		validaArquivo(){
			const LIMITE_TAMANHO_ARQUIVO = 100000;
			let mensagens = [];
			const { nome, extensaoArquivo, tamanho, periodicidade, descricao, isEdit, index } = this.state.arquivo;

			if(!nome || nome.trim().length === 0 ){
				mensagens.push({mensagem: "Nome é obrigatório."})
			} else if(!/^[a-zA-Z0-9]+$/.test(nome.trim())){
					mensagens.push({mensagem: "O nome do arquivo deve conter apenas letras e números"})
			} else {
				const nomeNormalizado = nome.trim().toLowerCase();
				const arquivos = this.state.grandeVolume.arquivos;
				const duplicado = arquivos.some((arq, idx) => 
					arq.nome.trim().toLowerCase() === nomeNormalizado && !(isEdit && idx === index)
				);
				if(duplicado){
					mensagens.push({mensagem: "Já existe um arquivo cadastrado com esse nome no conjunto de arquivos."})
				}
			}

			if(!extensaoArquivo ){
			 	mensagens.push({mensagem: "Extensão do arquivo é obrigatória."})
			}

			validaCamposNumericos(mensagens, tamanho, "Tamanho em MB (Megabytes)", true, false, false, LIMITE_TAMANHO_ARQUIVO);

			if(!periodicidade || periodicidade.trim().length === 0 ){
			 	mensagens.push({mensagem: "Periodicidade é obrigatória."})
			}

			if(!descricao || descricao.trim().length === 0 ){
				mensagens.push({mensagem: "Descrição é obrigatória."})
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
			 	throw new Error("Arquivo não preenchido corretamente.");
			}
		}

		carregarExtensoes() {
			this.setState({
				carregandoExtensoes: true,
			});
			api.get('/api/arquivo-gv/extensoes')
				.then(response => { 
					const extensoes = response.data;
					this.setState(prevState => ({
						extensoes
					}));
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as extensões disponíveis.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoExtensoes : false});
				});
		}

        carregarDirigentesTi() {
			this.setState({
				carregandoDirigentesTi: true,
			});
			api.get('/api/gestor/dirigente-ti')
				.then(response => { 
					const dirigentesTi = response.data;
					
					this.setState(prevState => {
						const grandeVolume = { ...prevState.grandeVolume };
						if (dirigentesTi.length === 1) {
							grandeVolume.cpfDirigenteTi = dirigentesTi[0].cpf;
						}
						return { dirigentesTi, grandeVolume };
					});
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os dirigentes de TI.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoDirigentesTi : false});
				});
		}

		carregarResponsaveisTecnicos() {
			this.setState({
				carregandoResponsaveisTecnicos: true,
			});
			api.get('/api/gestor/responsavel-tecnico')
				.then(response => { 
					const responsaveisTecnicos = response.data;
					
					this.setState(prevState => {
						const grandeVolume = { ...prevState.grandeVolume };
						if (responsaveisTecnicos.length === 1) {
							grandeVolume.cpfResponsavelTecnico = responsaveisTecnicos[0].cpf;
						}
						return { responsaveisTecnicos, grandeVolume };
					});
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar os responsáveis técnicos.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoResponsaveisTecnicos : false});
				});
		}

		carregarPeriodicidades() {
			api.get('/api/arquivo-gv/periodicidades')
				.then(response => { 
					this.setState(prevState => ({ periodicidades: response.data }));
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as periodicidades.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				});
		}

        scrollParaArquivo = () => {
            this.arquivosRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
            });
        };

		executaAndamento (url, mensagemSucesso, mensagemErro) {
			const { solicitacao } = this.state;

			const options = {
				method: 'put',
				url,
				data: solicitacao,
			}

			api(options)
				.then(response => { 
					this.setState({
						solicitacao: response.data,
					}) 
					this.props.exibeMensagemSucesso(mensagemSucesso);
				})
				.catch(erro => {
					const msg = getMessagemErro(mensagemErro, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		deferirSolicitacao() {
			const mensagemSucesso = "Solicitação de cadastro de usuário deferida com sucesso.";
			const mensagemErro = "Não foi possível deferir a solicitação de cadastro de usuário.";
			const url = '/api/auto-cadastro-usuario/deferir';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		rejeitarSolicitacao() {
			const mensagemSucesso = "Solicitação de cadastro de usuário rejeitada com sucesso.";
			const mensagemErro = "Não foi possível rejeitar a solicitação de cadastro de usuário.";
			const url = '/api/auto-cadastro-usuario/rejeitar';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

	}

) // redux
); // router